import type { IKpiRepository, KpiValueUpdateInput } from '../repositories/IKpiRepository.js';
import type { KpiValueEntity } from '../entities/KpiEntity.js';

export function createUpdateKpiValueUseCase({ kpiRepository }: { kpiRepository: IKpiRepository }) {
  return (id: string, input: KpiValueUpdateInput): Promise<KpiValueEntity> =>
    kpiRepository.updateKpiValue(id, input);
}
